import axiosInstance from "../../../helpers/api";

/** Available office hours for the logged-in student */
export const getOfficeHoursForStudent = () => {
  return axiosInstance.get("/students/office_hours");
};

export const applyForOfficeHour = (studentId, officeHourId) => {
  return axiosInstance.post(`/students/office_hours/apply/${studentId}/${officeHourId}`);
};

export const getUpcomingOfficeHoursForStudent = (studentId) => {
  return axiosInstance.get(`/students/office_hours/upcoming/${studentId}`);
};

export const getOfficeHoursHistoryForStudent = (studentId) => {
  return axiosInstance.get(`/students/office_hours/history/${studentId}`);
};
